import { Box, ButtonBase, TableCell } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { JSX } from "react";

import { SORTABLE, type SortDir, type SortKey } from "./ticketListConsts.js";

/** A sortable column header — label + active-direction arrow, with `aria-sort`
 * reflecting the current state. Extracted from `TicketListPage.tsx`. */
export function SortableTh({
  col,
  activeKey,
  activeDir,
  onSort,
  sx,
}: {
  col: keyof typeof SORTABLE;
  activeKey: SortKey;
  activeDir: SortDir;
  onSort: (k: SortKey) => void;
  sx?: SxProps<Theme>;
}): JSX.Element {
  const meta = SORTABLE[col]!;
  const isActive = activeKey === meta.key;
  return (
    <TableCell
      align="left"
      {...(sx ? { sx } : {})}
      aria-sort={isActive ? (activeDir === "asc" ? "ascending" : "descending") : "none"}
    >
      <ButtonBase
        onClick={() => onSort(meta.key)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontSize: "inherit",
          fontWeight: "inherit",
          color: "inherit",
          "&:hover": { color: "text.primary" },
        }}
      >
        {meta.label}
        <Box component="span" aria-hidden sx={{ opacity: isActive ? 0.9 : 0.3 }}>
          {isActive && activeDir === "asc" ? "▲" : "▼"}
        </Box>
      </ButtonBase>
    </TableCell>
  );
}
